<script setup></script>

<template>
  <div class="h-[21vh]">
    <VBusHelper :emitOnMounted="$constants.EVENTS.ADS.LIST_ALL.REFRESH" />
    <AdsLoadingError
      v-if="$stores.ads?.state?.list_all?.error"
      @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
    >
      <template #errorDescription>
        {{ $stores.ads?.state?.list_all?.error }}
      </template>
    </AdsLoadingError>
    <div v-else-if="$stores.ads?.state?.list_all?.list.length" class="">
      <SwipperView
        v-slot="{ position, isActive }"
        :nbTabs="$stores.ads?.state?.list_all?.list.length"
        loop
        autoPlay
      >
        <component
          :is="
            $stores.ads?.state?.list_all?.list[position]?.targetUrl
              ? 'a'
              : 'div'
          "
          :href="$stores.ads?.state?.list_all?.list[position]?.targetUrl"
          target="_blank"
          class="w-full h-[21vh] px-4 block"
        >
          <ImgComponent
            :src="$stores.ads?.state?.list_all?.list[position]?.pictureUrl"
            class="rounded-3xl object-cover w-full h-full"
            alt=""
          />
        </component>
      </SwipperView>
    </div>
    <div
      v-else-if="$stores.ads?.state?.list_all?.loading"
      class="shimmerContainer"
    >
      <SwipperView v-slot="{ position, isActive }" :nbTabs="3" loop autoPlay>
        <div class="w-full h-[21vh] px-4">
          <div class="shimmerElement w-full h-full rounded-3xl"></div>
        </div>
      </SwipperView>
    </div>
    <EmptyAds
      v-else
      @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
    />
  </div>
</template>
